/**
 * Regex pattern to match chat conversation routes
 * Matches: /chat/:conversationId or /app/chat/:conversationId (where conversationId is non-empty)
 * Does NOT match: /chat, /chat/, /chats, /chat-something
 */
const CHAT_CONVERSATION_PATTERN = /^(\/app)?\/chat\/[^/]+$/;

/**
 * Check if a given path is viewing a specific chat conversation
 * @param path - The current route path (e.g., from useLocation)
 * @returns true if viewing a conversation, false if just the chat list or other page
 */
export function isViewingChatConversation(path: string): boolean {
  return CHAT_CONVERSATION_PATTERN.test(path);
}

